import axios from "./api"
import { estimation } from "@/Api/api";
import isEmpty from "lodash/isEmpty";

const equipmentApi = {
    getEquipmentById(request) {
        const equipmentId = request.equipment_id;
        return axios.get(`/api/equipment/${equipmentId}`);
    },
    getEquipmentStashById(request) {
        const stash_id = request.stash_id;
        return axios.get(`/api/stash/${stash_id}`);
    },
    async generateEquipmentStash(request, estimate = false, title, estimateCallback = null) {
        const data = {
            quantity: !isEmpty(request.quantity) ? request.quantity : 2,
            quality: request.quality,
            influence: request.influence,
            tier: request.tier,
            stash_id: request.stash_id,
            creature_id: request.creature_id,
            style: request.style,
            edition: request.edition,
        };
        return estimation('/api/stash/generate', data, estimate, title, estimateCallback);
    },
    updateEquipment(item, stashId, clearedFields = []) {
        const equipmentId = item.id;
        const data = {
            name: item.name,
            description: item.description,
            ai_instructions: item.ai_instructions,
            magic_effects: item.magic_effects,
            cost: item.cost,
            weight: item.weight,
            damage: item.damage,
            range: item.range,
            armor: item.armor,
            armor_class: item.armor_class,
            properties: item.properties,
            stash_id: stashId,
            damage_dice: item.damage_dice,
            heal_dice: item.heal_dice,
            clear_fields: clearedFields,
        }
        return axios.patch(`/api/equipment/${equipmentId}`, data)
    },
    deleteEquipment(equipmentId, stashId) {
        return axios.delete(`/api/equipment/${equipmentId}`, {
            params: { stash_id: stashId }
        });
    },
    getUsersEquipmentHistory(request) {
        return axios.get(`/api/stash/history?range_start=${request.rangeStart}&result_limit=${request.resultLimit}`);
    },
    postRegenerateIllustration(request, estimate = false, title, estimateCallback = null) {
        return estimation(`/api/equipment/${request.equipment_id}/regenerate-illustration`, request, estimate, title, estimateCallback);
    },
    patchEquipmentIllustration(request) {
        return axios.patch(`/api/equipment/${request.equipment_id}/change-illustration`, request);
    },
    postEquipmentSearch(request) {
        return axios.post('/api/equipment/search', request);
    },
    addEquipmentToStash(stashId, equipmentId) {
        return axios.post(`/api/stash/${stashId}/add`, {
            equipment_id: equipmentId
        });
    },
}

export default equipmentApi;
